<aside id="sidebar" class="sidebar break-point-lg has-bg-image">
  <div class="sidebar-layout">
    <div class="sidebar-header">
      <div class="small-logo cursor-pointer" routerLink="/dashboard">
        <img
          src="../../../assets/Krid/img/small-logo.svg"
          class="img img-fluid"
          alt=""
        />
      </div>
      <div class="pro-sidebar-logo cursor-pointer" routerLink="/dashboard">
        <img
          src="../../../assets/Krid/img/portal-logo.svg"
          class="img img-fluid"
          alt=""
        />
      </div>
    </div>
    <div class="user-admin">
      <div class="user-box">
        <div class="profile-container" (click)="toggleDropdown()">
          <div class="profile-header">
            <img
              [src]="
                userImage
                  ? userImage
                  : '../../../assets/img/default-user-profile.svg'
              "
              alt="Profile Picture"
              class="profile-pic"
              (error)="handleImageError()"
            />
            <div class="profile-info">
              <div class="profile-name">{{ userName }}</div>
              <div class="profile-role">{{ roleName }}</div>
            </div>

            <div class="profile-icon">
              <i [class]="isOpen ? 'fas fa-times' : 'fas fa-chevron-down'"></i>
            </div>
          </div>
          <div class="profile-dropdown" *ngIf="isOpen">
            <button
              mat-menu-item
              [class.active]="activeMenuItem === 'My Account'"
              (click)="addEditViewUser()"
            >
              <i class="fas fa-user-circle"></i>
              <span>My Profile</span>
              <i class="fa fa-angle-right right-arrow"></i>
            </button>

            <button
              mat-menu-item
              [class.active]="activeMenuItem === 'Change Password'"
              (click)="changePassword()"
            >
              <i class="fas fa-lock"></i>
              <span>Change Password</span>
              <i class="fa fa-angle-right right-arrow"></i>
            </button>

            <button
              mat-menu-item
              [class.active]="activeMenuItem === 'Login Devices'"
              (click)="loginDevicesList()"
              (click)="toggleDropdown('Login Devices')"
            >
              <i class="fa-solid fa-file"></i>
              <span>Authentic - Devices</span>
              <i class="fa fa-angle-right right-arrow"></i>
            </button>

            <button
              mat-menu-item
              routerLink="/activity-log"
              routerLinkActive="active"
              (click)="toggleDropdown('Activity Logs')"
            >
              <i class="fa fa-history"></i>
              <span>Activity Logs</span>
              <i class="fa fa-angle-right right-arrow"></i>
            </button>

            <button
              mat-menu-item
              [class.active]="activeMenuItem === 'Logout'"
              (click)="logOut('logout')"
            >
              <i class="fas fa-power-off"></i>
              <span>Logout</span>
              <i class="fa fa-angle-right right-arrow"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="sidebar-content" [class.userAdminOpen]="isDropdownOpen">
      <nav class="menu open-current-submenu" id="myNav">
        <ul>
          <li
            *ngFor="let menuItem of menuItems"
            class="menu-item"
            routerLinkActive="active"
          >
            <a
              *ngIf="menuItem.showInMenu"
              class="nav-link collapsed"
              (click)="toggleSubMenu(menuItem, null, $event)"
              [routerLink]="
                menuItem.subMenus &&
                menuItem.subMenus.length > 0 &&
                havingSubMenu(menuItem)
                  ? null
                  : menuItem.url
              "
              [attr.data-target]="'#submenu' + menuItem.id"
            >
              <span class="menu-icon">
                <img
                  *ngIf="
                    menuItem.icon != null &&
                    menuItem.icon !== '' &&
                    menuItem.icon !== undefined
                  "
                  [src]="'../../../assets/Krid/img/' + menuItem.icon"
                  alt="Icon"
                />
              </span>
              <span class="menu-title">{{ menuItem.name }}</span>
              <img src="../../../assets/Krid/img/notes-icon-new.svg" alt="" *ngIf="menuItem.url == '/notes' && isNotePending">
              <i
                *ngIf="
                  menuItem.subMenus &&
                  menuItem.subMenus.length > 0 &&
                  havingSubMenu(menuItem)
                "
                [class]="
                  menuItem.isOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down'
                "
              >
              </i>
            </a>
            <div
              class="collapse position-relative"
              [id]="'submenu' + menuItem.id"
              [ngClass]="{ show: menuItem.isOpen }"
            >
              <ul
                *ngIf="
                  menuItem.subMenus &&
                  menuItem.subMenus.length > 0 &&
                  havingSubMenu(menuItem)
                "
                class="submenu-list"
              >
                <li
                  *ngFor="let subMenu of menuItem.subMenus"
                  class="menu-item"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <a
                    *ngIf="subMenu.showInMenu"
                    class="nav-link collapsed py-1"
                    (click)="toggleSubMenu(subMenu, menuItem, $event)"
                    [routerLink]="
                      subMenu.subItems && subMenu.subItems.length > 0
                        ? null
                        : menuItem.url + subMenu.url
                    "
                    routerLinkActive="active"
                    [attr.data-target]="'#submenu' + subMenu.id"
                  >
                    <span class="menu-icon">
                      <img
                        *ngIf="
                          subMenu.icon !== null &&
                          subMenu.icon !== '' &&
                          subMenu.icon !== undefined
                        "
                        [src]="'../../../assets/Krid/img/' + subMenu.icon"
                        alt="Icon"
                      />
                    </span>
                    <span>{{ subMenu.name }}</span>
                    <i
                      *ngIf="
                        subMenu.subItems &&
                        subMenu.subItems.length > 0 &&
                        menuItem.showInMenu
                      "
                      [class]="
                        subMenu.isOpen
                          ? 'fas fa-chevron-up'
                          : 'fas fa-chevron-down'
                      "
                    >
                    </i>
                  </a>
                  <div
                    class="collapse child-submenu"
                    [id]="'submenu' + subMenu.id"
                    [ngClass]="{ show: subMenu.isOpen }"
                  >
                    <ul
                      *ngIf="subMenu.subItems && subMenu.subItems.length > 0"
                      class="submenu-list"
                    >
                      <li
                        *ngFor="let subItem of subMenu.subItems"
                        class="menu-item"
                        routerLinkActive="active"
                      >
                        <a
                          href="javascript:void(0)"
                          (click)="toggleChildMenu(subItem, $event)"
                          [routerLink]="
                            menuItem.url + subMenu.url + subItem.url
                          "
                          routerLinkActive="active"
                        >
                          <span class="menu-icon">
                            <img
                              *ngIf="
                                subItem.icon != null &&
                                subItem.icon !== '' &&
                                subItem.icon !== undefined
                              "
                              [src]="'../../../assets/Krid/img/' + subItem.icon"
                              alt="Icon"
                            />
                          </span>
                          <span class="me-auto">{{ subItem.name }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </nav>
    </div> 
  </div>
</aside>
<div id="overlay" class="overlay"></div>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Profile</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="d('Cross click')"
    ></button>
  </div>
  <div class="modal-body">
    <div class="profile-img">
      <img
        class="user-img"
        src="../../../assets/Krid/img/user-img.jpg"
        alt=""
      />
      <div class="fileUpload">
        <input type="file" class="upload" />
        <img src="../../../assets/Krid/img/edit-file-icon.svg" alt="" />
      </div>
    </div>
    <form>
      <div class="row">
        <div class="col-md-6 mt-4">
          <div class="form-group">
            <label for="firstname"
              >First Name<span class="text-danger">*</span></label
            >
            <input
              type="text"
              class="form-control"
              id="firstname"
              placeholder="Mauricio Zanon"
            />
          </div>
        </div>
        <div class="col-md-6 mt-4">
          <div class="form-group">
            <label for="companyname"
              >Company Name<span class="text-danger">*</span></label
            >
            <input
              type="text"
              class="form-control"
              id="companyname"
              placeholder="Apex Surveying Solutions"
            />
          </div>
        </div>
        <div class="col-md-12 mt-4">
          <div class="form-group">
            <label for="address"
              >Address Line 1<span class="text-danger">*</span></label
            >
            <input
              type="text"
              class="form-control"
              id="address"
              placeholder="711 Windsor Road, Imperial Wharf, The Blvd."
            />
          </div>
        </div>
        <div class="col-md-6 mt-4">
          <div class="form-group">
            <label for="city">City<span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              id="city"
              placeholder="Kensington"
            />
          </div>
        </div>
        <div class="col-md-6 mt-4">
          <div class="form-group">
            <label for="country"
              >Country<span class="text-danger">*</span></label
            >
            <input
              type="text"
              class="form-control"
              id="country"
              placeholder="United Kingdom"
            />
          </div>
        </div>
        <div class="col-md-6 mt-4">
          <div class="form-group">
            <label for="postcode"
              >Postcode<span class="text-danger">*</span></label
            >
            <input
              type="text"
              class="form-control"
              id="postcode"
              placeholder="SW37 0TA"
            />
          </div>
        </div>
        <div class="col-md-6 mt-4">
          <div class="form-group">
            <label for="email">Email<span class="text-danger">*</span></label>
            <input
              type="email"
              class="form-control"
              id="email"
              placeholder="abcd@gmail.com"
            />
          </div>
        </div>
        <div class="col-md-6 mt-4">
          <div class="form-group">
            <label for="phoneno"
              >Phone No.<span class="text-danger">*</span></label
            >
            <input
              type="text"
              class="form-control"
              id="phoneno"
              placeholder="1234 123 1234"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="('Save click')">
      Update
    </button>
  </div>
</ng-template>
